import { Action, createReducer, on } from "@ngrx/store";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { BillableProposalsState } from "../../models/mp-admin/billable-proposals-state";

export const initialBillableProposalsState: BillableProposalsState = {
	proposals: [],
	loading: false,
	error: null
};

const reducer = createReducer(
	initialBillableProposalsState,

	on(MpAdminActions.billableProposals.getApi, (state) => ({
		...state,
		loading: true,
		error: null
	})),

	on(MpAdminActions.billableProposals.getSuccess, (state, { proposals }) => ({
		...state,
		proposals,
		loading: false,
		error: null
	})),

	on(MpAdminActions.billableProposals.getFail, (state, { error }) => ({
		...state,
		loading: false,
		error
	})),

	// Listen for invoice creation success and remove those proposals
	on(MpAdminActions.invoices.createSuccess, (state, { invoiceCreationResponse }) => {
		if (invoiceCreationResponse?.warnings?.length > 0) {
			// If there are warnings, don't update the state - return the current state as is
			return state;
		}
		const invoicedProposalIds = invoiceCreationResponse?.invoice?.proposals?.map(
			(proposalForInvoicing) => proposalForInvoicing.proposalId
		);
		return {
			...state,
			proposals: state.proposals?.filter(
				(proposalForInvoicing) =>
					!invoicedProposalIds?.includes(proposalForInvoicing.proposalId)
			)
		};
	})
);

export function billableProposalsReducer(state: BillableProposalsState, action: Action) {
	return reducer(state, action);
}
